<template>
  <div class="pc-competition-video">
    <h2>
      {{
        config_type == "review_r1"
          ? "一轮"
          : config_type == "review_r2"
          ? "二轮"
          : "三轮"
      }}评审
    </h2>
    <El-button v-if="!isEditting" @click="edit()" class="edit-btn"
      >编辑</El-button
    >
    <El-button v-if="isEditting" @click="edit()" class="edit-btn"
      >完成</El-button
    >

    <ul class="pc-competition-video-list">
      <li class="video-item" v-for="(item, index) in reviewList" :key="index">
        <div class="video-item-right">
          <div class="video-content">
            <div class="video-introduction">
              <div class="title">
                <h4>评审规则{{ index + 1 }}</h4>
                <span v-if="!item.isEdittingReview">
                  {{ item.chinese_review_standard }}
                </span>
                <el-input
                  v-if="isEditting && item.isEdittingReview"
                  v-model="item.chinese_review_standard"
                  placeholder="请输入中文"
                ></el-input>
              </div>
              <div class="description">
                <h4>评审规则{{ index + 1 }}英文</h4>
                <span v-if="!item.isEdittingReview">
                  {{ item.english_review_standard }}
                </span>
                <el-input
                  v-if="isEditting && item.isEdittingReview"
                  v-model="item.english_review_standard"
                  placeholder="请输入英文"
                ></el-input>
              </div>
              <div class="description">
                <h4>权重</h4>
                <span v-if="!item.isEdittingReview">
                  {{ item.weight }}
                </span>
                <el-input
                  v-if="isEditting && item.isEdittingReview"
                  v-model="item.weight"
                  placeholder="请输入权重"
                ></el-input>
              </div>
              <div class="title" v-if="item.detail_rule_1_is_show == true">
                <h4>细则1</h4>
                <span v-if="!item.isEdittingReview">
                  {{ item.chinese_detail_rule_1 }}
                </span>
                <el-input
                  v-if="isEditting && item.isEdittingReview"
                  v-model="item.chinese_detail_rule_1"
                  placeholder="请输入中文"
                ></el-input>
              </div>

              <div
                class="description"
                v-if="item.detail_rule_1_is_show == true"
              >
                <h4>细则1英文</h4>
                <span v-if="!item.isEdittingReview">
                  {{ item.english_detail_rule_1 }}
                </span>
                <el-input
                  v-if="isEditting && item.isEdittingReview"
                  v-model="item.english_detail_rule_1"
                  placeholder="请输入英文"
                ></el-input>
              </div>
              <div class="title" v-if="item.detail_rule_2_is_show == true">
                <h4>细则2</h4>
                <span v-if="!item.isEdittingReview">
                  {{ item.chinese_detail_rule_2 }}
                </span>
                <el-input
                  v-if="isEditting && item.isEdittingReview"
                  v-model="item.chinese_detail_rule_2"
                  placeholder="请输入中文"
                ></el-input>
              </div>
              <div
                class="description"
                v-if="item.detail_rule_2_is_show == true"
              >
                <h4>细则2英文</h4>
                <span v-if="!item.isEdittingReview">
                  {{ item.english_detail_rule_2 }}
                </span>
                <el-input
                  v-if="isEditting && item.isEdittingReview"
                  v-model="item.english_detail_rule_2"
                  placeholder="请输入英文"
                ></el-input>
              </div>
              <div class="title" v-if="item.detail_rule_3_is_show == true">
                <h4>细则3</h4>
                <span v-if="!item.isEdittingReview">
                  {{ item.chinese_detail_rule_3 }}
                </span>
                <el-input
                  v-if="isEditting && item.isEdittingReview"
                  v-model="item.chinese_detail_rule_3"
                  placeholder="请输入中文"
                ></el-input>
              </div>
              <div
                class="description"
                v-if="item.detail_rule_3_is_show == true"
              >
                <h4>细则3英文</h4>
                <span v-if="!item.isEdittingReview">
                  {{ item.english_detail_rule_3 }}
                </span>
                <el-input
                  v-if="isEditting && item.isEdittingReview"
                  v-model="item.english_detail_rule_3"
                  placeholder="请输入英文"
                ></el-input>
              </div>
              <div class="title" v-if="item.detail_rule_4_is_show == true">
                <h4>细则4</h4>
                <span v-if="!item.isEdittingReview">
                  {{ item.chinese_detail_rule_4 }}
                </span>
                <el-input
                  v-if="isEditting && item.isEdittingReview"
                  v-model="item.chinese_detail_rule_4"
                  placeholder="请输入中文"
                ></el-input>
              </div>
              <div
                class="description"
                v-if="item.detail_rule_4_is_show == true"
              >
                <h4>细则4英文</h4>
                <span v-if="!item.isEdittingReview">
                  {{ item.english_detail_rule_4 }}
                </span>
                <el-input
                  v-if="isEditting && item.isEdittingReview"
                  v-model="item.english_detail_rule_4"
                  placeholder="请输入英文"
                ></el-input>
              </div>
              <div class="title" v-if="item.detail_rule_5_is_show == true">
                <h4>细则5</h4>
                <span v-if="!item.isEdittingReview">
                  {{ item.chinese_detail_rule_5 }}
                </span>
                <el-input
                  v-if="isEditting && item.isEdittingReview"
                  v-model="item.chinese_detail_rule_5"
                  placeholder="请输入中文"
                ></el-input>
              </div>
              <div
                class="description"
                v-if="item.detail_rule_5_is_show == true"
              >
                <h4>细则5英文</h4>
                <span v-if="!item.isEdittingReview">
                  {{ item.english_detail_rule_5 }}
                </span>
                <el-input
                  v-if="isEditting && item.isEdittingReview"
                  v-model="item.english_detail_rule_5"
                  placeholder="请输入英文"
                ></el-input>
              </div>
              <div class="title" v-if="item.detail_rule_6_is_show == true">
                <h4>细则6</h4>
                <span v-if="!item.isEdittingReview">
                  {{ item.chinese_detail_rule_6 }}
                </span>

                <el-input
                  v-if="isEditting && item.isEdittingReview"
                  v-model="item.chinese_detail_rule_6"
                  placeholder="请输入中文"
                ></el-input>
              </div>
              <div
                class="description"
                v-if="item.detail_rule_6_is_show == true"
              >
                <h4>细则6英文</h4>
                <span v-if="!item.isEdittingReview">
                  {{ item.english_detail_rule_6 }}
                </span>
                <el-input
                  v-if="isEditting && item.isEdittingReview"
                  v-model="item.english_detail_rule_6"
                  placeholder="请输入英文"
                ></el-input>
              </div>
            </div>
          </div>
          <div
            class="change"
            @click="changed(index, item)"
            v-if="isEditting && !item.isEdittingReview"
          >
            <span>修改</span>
          </div>
          <div class="video-caption">
            <div class="details" v-if="isEditting && item.isEdittingReview">
              <span @click="addDetail(index)">添加细则</span>
            </div>
            <div class="details" v-if="isEditting && item.isEdittingReview">
              <span @click="deleteDetail(index)">删除细则</span>
            </div>
            <div class="details" v-if="isEditting && item.isEdittingReview">
              <span @click="changeDetail(index, item)">确认</span>
            </div>
            <div class="details" v-if="isEditting && item.isEdittingReview">
              <span @click="cancelDetail(index, item)">取消</span>
            </div>
          </div>
        </div>
      </li>
      <div @click="addReview()" class="add-btn" v-show="isEditting">
        <span>添加标准</span>
      </div>
      <div class="update" v-if="isEditting">
        <span @click="deleteReview()">删除标准</span>
      </div>
    </ul>

    <DeleteDialog
      :dialogVisible="deleteDialogVisible"
      @isCancel="closeDelete"
      @isDelete="deleteConfirm"
    />
  </div>
</template>

<script>
import DeleteDialog from "../../../componentSet/DeleteDialog";
import {
  competitionReview_Api,
  createCompetitionReview_Api,
  updateCompetitionReview_Api,
  deleteCompetitionReview_Api,
} from "../../../../apis/competition.api";
export default {
  props: ["config_type", "competitionDetail"],
  data() {
    return {
      isEditting: false,
      deleteDialogVisible: false,
      reviewList: [],
      delete_index: null,
      introduce: {},
      review_list: {
        chinese_detail_rule_1: null,
        chinese_detail_rule_2: null,
        chinese_detail_rule_3: null,
        chinese_detail_rule_4: null,
        chinese_detail_rule_5: null,
        chinese_detail_rule_6: null,
        chinese_review_standard: null,
        detail_rule_1_is_show: false,
        detail_rule_2_is_show: false,
        detail_rule_3_is_show: false,
        detail_rule_4_is_show: false,
        detail_rule_5_is_show: false,
        detail_rule_6_is_show: false,
        english_detail_rule_1: null,
        english_detail_rule_2: null,
        english_detail_rule_3: null,
        english_detail_rule_4: null,
        english_detail_rule_5: null,
        english_detail_rule_6: null,
        english_review_standard: null,
        weight: null,
        isEdittingReview: true,
        review_id: null,
      },
    };
  },
  watch: {
    config_type(newVal, oldVal) {
      console.log(this.config_type);
      competitionReview_Api(this.$route.query.id, this.config_type).then(
        (res) => {
          this.reviewList = res.data;
          this.reviewList.forEach((item) => {
            item.isEdittingReview = false;
          });

          console.log(this.reviewList);

          this.reviewList.forEach((item) => {
            for (let key in item) {
              if (key.indexOf("detail_rule") != -1) {
                console.log(123);
                if (item[key]) {
                  item[key.substring(8) + "_is_show"] = true;
                } else {
                  item[key.substring(8) + "_is_show"] = false;
                }
              }
            }
          });
        }
      );
    },
  },

  mounted() {},
  components: {
    DeleteDialog,
  },
  methods: {
    edit() {
      this.isEditting = !this.isEditting;
      if (!this.isEditting) {
        this.reviewList.forEach((item) => {
          item.isEdittingReview = false;
        });
      }
    },
    changed(index, item) {
      item.isEdittingReview = true;
      this.$set(this.reviewList, index, item);
    },
    addDetail(index) {
      for (let i = 0; i < 6; i++) {
        if (this.reviewList[index]["detail_rule_" + i + "_is_show"] == false) {
          this.$set(
            this.reviewList[index],
            "detail_rule_" + i + "_is_show",
            true
          );
          break;
        }
      }
      console.log(this.reviewList);
      this.$forceUpdate();
    },
    deleteDetail(index) {
      for (let i = 6; i > 0; i--) {
        if (this.reviewList[index]["detail_rule_" + i + "_is_show"] == true) {
          this.$set(
            this.reviewList[index],
            "detail_rule_" + i + "_is_show",
            false
          );
          break;
        }
      }
      console.log(this.reviewList);
      this.$forceUpdate();
    },
    changeDetail(index, item) {
      console.log(this.reviewList[index].id)
      item.isEdittingReview = false;
      this.$set(this.reviewList, index, item);
      if (this.reviewList[index].id) {
        this.reviewList[index].review_id = this.reviewList[index].id;
        updateCompetitionReview_Api(this.reviewList[index]).then((res) => {
          console.log(res);
          this.$global.success(this, "修改成功");
        });
        console.log(1111);
      } else {
        createCompetitionReview_Api({
          competition_id: this.competitionDetail.id,
          config_type: this.config_type,
          review_list: [this.review_list],
        })
          .then((res) => {
            console.log(res);
            this.$global.success(this, "创建成功！", null);
          })
          .catch(() => {
            this.$global.error(this, "创建失败！", null);
          });
        console.log(2222);
      }
    },

    addReview() {
     let review_list= {
        chinese_detail_rule_1: null,
        chinese_detail_rule_2: null,
        chinese_detail_rule_3: null,
        chinese_detail_rule_4: null,
        chinese_detail_rule_5: null,
        chinese_detail_rule_6: null,
        chinese_review_standard: null,
        detail_rule_1_is_show: false,
        detail_rule_2_is_show: false,
        detail_rule_3_is_show: false,
        detail_rule_4_is_show: false,
        detail_rule_5_is_show: false,
        detail_rule_6_is_show: false,
        english_detail_rule_1: null,
        english_detail_rule_2: null,
        english_detail_rule_3: null,
        english_detail_rule_4: null,
        english_detail_rule_5: null,
        english_detail_rule_6: null,
        english_review_standard: null,
        weight: null,
        isEdittingReview: true,
        review_id: null,
      };
      this.reviewList.push(review_list);
      this.review_list = review_list;
    },
    deleteConfirm() {
      deleteCompetitionReview_Api({
        review_id: this.reviewList[this.reviewList.length - 1].id,
      }).then((res) => {});
      this.reviewList.splice(this.reviewList.length - 1, 1);
      this.deleteDialogVisible = false;
    },
    cancelDetail(index, item) {
      item.isEdittingReview = false;
      this.$set(this.reviewList, index, item);
    },
    closeDelete() {
      console.log(1324132);
      this.deleteDialogVisible = false;
    },
    deleteReview() {
      this.deleteDialogVisible = true;
    },
    //     validateForm(formData) {
    //   //表单校验
    //   if (!formData.weight) {
    //     this.$global.error(this, "请输入权重");
    //     return false;
    //   }
    //   return formData;
    // },
  },
};
</script>

<style scoped lang='scss'>
.pc-competition-video {
  @include box-model;
  .edit-btn {
    right: 30px;
  }
  .pc-competition-video-list {
    width: 100%;
    .video-item {
      display: flex;
      width: 100%;
      margin-bottom: 20px;
      padding-bottom: 20px;
      //   border-bottom: 1px $timeBtn dashed;
      .video-item-left {
        position: relative;
        width: 285px !important;
        height: 160px;
        border: 1px solid #979797;
        margin-right: 20px;
        video {
          width: 285px;
          height: 160px;
        }
        img {
          width: 285px;
          height: 160px;
        }
      }
      .video-item-right {
        width: calc(100% - 285px);
        position: relative;
        .change {
          width: 100px;
          text-align: center;
          padding: 8px 10px;
          font-size: 11px;
          border: 1px solid $universityBorder;
          background: $universityBackground;
          margin-right: 20px;
          margin-bottom: 10px;
          color: $timeBtn;
          font-family: $english;
          border-radius: 4px;
          border: 1px dashed $timeBtn;
          background: none;
          cursor: pointer;
        }
        .video-content {
          display: flex;

          .video-image {
            img {
              width: 220px;
              height: 133px;
            }
            .upload-image {
              margin-right: 25px;
              margin-bottom: 15px;
            }
          }

          .video-introduction {
            width: 100%;

            .title {
              margin-bottom: 10px;
            }
            .description {
              margin-bottom: 10px;
            }
            .title,
            .description {
              display: flex;

              h4 {
                flex-shrink: 0;
                font-size: 14px;
                width: 100px;
                font-weight: 600;
                text-align: right;
                margin-right: 20px;
                align-self: center;
                display: flex;
                justify-content: flex-end;
              }
              span {
                font-size: 14px;
              }
            }
          }
        }
        .video-caption {
          margin-top: 10px;
          display: flex;
          font-size: 12px;
          align-items: flex-start;
          .caption {
            width: 220px;
            font-size: 12px;
            margin-right: 20px;
          }
          .details {
            width: 100px;
            text-align: center;
            padding: 8px 10px;
            font-size: 11px;
            border: 1px solid $universityBorder;
            background: $universityBackground;
            margin-right: 20px;
            margin-bottom: 10px;
            color: $timeBtn;
            font-family: $english;
            border-radius: 4px;
            border: 1px dashed $timeBtn;
            background: none;
            cursor: pointer;
          }

          .process {
            display: flex;
            width: 400px;
            .process-bar {
              width: 300px;
            }
          }
        }
      }

      .video-item-bottom {
        font-size: 14px;
        width: 80%;
        min-width: 700px;
        color: #434343;
        line-height: 21px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        h4 {
          font-size: 14px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #434343;
          line-height: 21px;
        }
        /deep/ .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
          background-color: #409eff;
          border-color: #409eff;
        }
        /deep/
          .el-checkbox__input.is-disabled.is-checked
          .el-checkbox__inner::after {
          border-color: #fff;
        }
        /deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
          color: #000;
        }
        /deep/ .el-input__inner {
          width: 90%;
          height: 40px;
          border-radius: 4px;
          border: 1px solid #dcdfe6;
        }
        /deep/ .el-input:first-of-type {
          margin-top: 0px;
        }
        /deep/ .el-input {
          margin-bottom: 10px;
        }
        textarea {
          width: 90%;
          height: 60px;
          border-radius: 4px;
          border: 1px solid #dcdfe6;
          padding-left: 15px;
          outline-color: #dcdfe6;
          resize: none;
        }
        /deep/ input:-ms-input-placeholder,
        /deep/ textarea:-ms-input-placeholder {
          color: #999999;
        }
        /deep/ input::-webkit-input-placeholder,
        /deep/ textarea::-webkit-input-placeholder {
          color: #999999;
        }
        p {
          margin-top: 10px;
          width: 1200px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #434343;
          line-height: 21px;
        }
        .pc-video-content-bottom-subtitle {
          display: flex;
          span {
            display: inline-block;
            width: 100px;
            height: 26px;
            background: #ffffff;
            border-radius: 4px 4px 4px 4px;
            border: 1px solid #dcdfe6;
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-right: 30px;
            // text-align: center;
            strong {
              // width: 48px;
              margin-left: 11px;
              font-size: 12px;
              // font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #5470c6;
              line-height: 12px;
              text-align: left;
            }
            i {
              display: inline-block;
              margin-top: -1px;
              // margin-right: -16px;
              // margin-left: 11px;
              width: 19px;
              height: 26px;
              background: #dcdfe6;
              border-radius: 4px;
              border: 1px solid #dcdfe6;
              color: #5470c6;
              text-align: right;
            }

            /deep/ .icon-zhuanhuan:before {
              font-size: 10px;
            }
            /deep/ .icon-shangchuanicon:before {
              font-size: 10px;
            }
          }
          /deep/ .el-upload--text {
            width: 100px;
            display: flex;
            justify-content: space-between;
            i {
              margin-top: 0;
              border-radius: 0 4px 4px 0 !important;
              display: inline-block;
              text-align: center;
            }
          }
          /deep/ .el-button--mini {
            // border-radius: 4px 0 0 4px !important;
            border: none;
            margin-left: 11px;
            margin-top: 1px;

            height: 24px;
            padding: 0;
            text-align: center;
            line-height: 26px;
          }
          /deep/ .el-button--primary {
            background-color: #fff;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #646464;
            font-size: 12px;
          }
        }
      }
      .video-item-position {
        width: 40px;
        height: 100px;
        text-align: center;
        background: #ffffff;
        box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
        border-radius: 20px;
        display: none;
        p {
          margin-bottom: 10px;
        }
        .pc-video-position-top {
          margin-top: 15px;
          // margin-bottom: 21px;
        }
      }
    }
  }
  .add-btn {
    display: inline-block;
    width: 110px;
    height: 40px;
    margin-top: 40px;
    margin-bottom: 40px;
    cursor: pointer;
    text-align: center;
    line-height: 40px;
    border-radius: 4px;
    border: 1px #5470c6 dashed;
    span {
      font-size: 14px;
      text-align: center;
      color: #5470c6;
    }
  }
  .update {
    display: inline-block;
    float: right;
    width: 110px;
    height: 40px;
    margin-top: 40px;
    margin-bottom: 40px;
    cursor: pointer;
    text-align: center;
    line-height: 40px;
    border-radius: 4px;
    border: 1px #5470c6 dashed;
    span {
      font-size: 14px;
      text-align: center;
      color: #5470c6;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/admin/competition/components/CompetitionReview.vue